import appLocaleData from 'react-intl/locale-data/en';
import enMessages from '../locales/en_US';

interface LanguageData {
  messages: Record<string, any>;
  locale: string;
  data: any;
}

const EnLang: LanguageData = {
  messages: {
    ...enMessages,
  },
  locale: 'en-US',
  data: appLocaleData,
};

export default EnLang;
